module.exports = __webpack_public_path__ + "img/services-case3-2.4d15b9b2.png";